import { useEffect, useMemo, useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";
import { db } from "~/db/db";
import prepareForOptions from "~services/utils/prepareForOptions";
import { getColumnIntoKey } from "~pages/PriceSearchV2/utils/initializerHelpers";

const usePesquisaCanalDistribuicao = (formikRef, pesquisaGrupoMaterialId = 0) => {
  const pesquisaCanalDistribuicaoSelect = useSelect("pesquisaCanaisDistribuicao");
  const [pesquisaCanalDistribuicao, setPesquisaCanalDistribuicao] = useState(0);
  const [pesquisaCanalDistribuicaoObjeto, setPesquisaCanalDistribuicaoObjeto] = useState({});
  const [fila, setFila] = useState(null);

  const [pesquisaCanaisDistribuicao, setPesquisaCanaisDistribuicao] = useState([]);
  const [pesquisaGrupoMaterialCanaisDistribuicao, setPesquisaGrupoMaterialCanaisDistribuicao] = useState([]);

  useEffect(() => {
    const fetchPesquisaCanaisDistribuicao = async () => {
      const canais = [];
      await db.pesquisaCanalDistribuicao.each((canal) => {
        canais.push(canal);
      });
      setPesquisaCanaisDistribuicao(canais);
    };

    const fetchPesquisaGrupoMaterialCanaisDistribuicao = async () => {
      const grupos = [];
      await db.pesquisaGrupoMaterialCanalDistribuicao.each((grupo) => {
        grupos.push(grupo);
      });
      setPesquisaGrupoMaterialCanaisDistribuicao(grupos);
    };

    fetchPesquisaCanaisDistribuicao();
    fetchPesquisaGrupoMaterialCanaisDistribuicao();
  }, []);

  //OPTIONS
  const pesquisaGrupoMaterialCanalDistribuicoes = useMemo(() => {
    const result = {};
    if (pesquisaGrupoMaterialCanaisDistribuicao && pesquisaGrupoMaterialCanaisDistribuicao.length > 0) {
      for (const e of pesquisaGrupoMaterialCanaisDistribuicao) {
        result[e.pesquisaGrupoMaterialId + "/" + e.pesquisaCanalDistribuicaoId] = true;
      }
    }
    return result;
  }, [pesquisaGrupoMaterialCanaisDistribuicao]);

  const optionPesquisaCanalDistribuicao = useMemo(() => {
    let temp = [];

    if (pesquisaCanaisDistribuicao?.length && pesquisaGrupoMaterialId && pesquisaGrupoMaterialId != 0) {
      temp = (pesquisaCanaisDistribuicao || []).filter(
        (e) =>
          e.ativo &&
          Object.entries(pesquisaGrupoMaterialCanalDistribuicoes).length > 0 &&
          pesquisaGrupoMaterialCanalDistribuicoes[pesquisaGrupoMaterialId + "/" + e.id]
      );
    }
    return prepareForOptions(temp, ["nome"], "id");
  }, [pesquisaGrupoMaterialCanalDistribuicoes, pesquisaCanaisDistribuicao, pesquisaGrupoMaterialId]);

  useEffect(() => {
    if (
      pesquisaCanalDistribuicao &&
      pesquisaGrupoMaterialId &&
      pesquisaGrupoMaterialId != 0 &&
      pesquisaGrupoMaterialCanalDistribuicoes
    ) {
      const exists = (pesquisaCanaisDistribuicao || []).find(
        (e) =>
          e.id == pesquisaCanalDistribuicao &&
          Object.entries(pesquisaGrupoMaterialCanalDistribuicoes).length > 0 &&
          pesquisaGrupoMaterialCanalDistribuicoes[pesquisaGrupoMaterialId + "/" + e.id]
      );
      if (!exists) {
        onChangePesquisaCanalDistribuicao({
          value: null,
        });
      }
    }
  }, [optionPesquisaCanalDistribuicao, pesquisaGrupoMaterialId]);

  //PESQUISA-GRUPO-MATERIAL-CANAL-DISTRIBUICAO

  useEffect(() => {
    if (
      fila &&
      pesquisaCanaisDistribuicao &&
      pesquisaCanaisDistribuicao.length > 0 &&
      pesquisaGrupoMaterialCanalDistribuicoes &&
      Object.keys(pesquisaGrupoMaterialCanalDistribuicoes).length > 0
    )
      setPesquisaCanalDistribuicaoSelect(fila);

    if (pesquisaCanaisDistribuicao?.length > 0)
      setPesquisaCanalDistribuicaoObjeto(getColumnIntoKey({ data: pesquisaCanaisDistribuicao, prefix: "id-" }));
  }, [fila, pesquisaCanaisDistribuicao, pesquisaGrupoMaterialCanalDistribuicoes]);

  function setPesquisaCanalDistribuicaoSelect(value) {
    if (
      pesquisaCanaisDistribuicao &&
      pesquisaCanaisDistribuicao.length > 0 &&
      pesquisaGrupoMaterialCanalDistribuicoes &&
      Object.keys(pesquisaGrupoMaterialCanalDistribuicoes).length > 0
    ) {
      const optionCanalDistribuicao = (pesquisaCanaisDistribuicao || []).find(
        (optCanalDistribuicao) => optCanalDistribuicao.id == value
      );

      if (optionCanalDistribuicao) {
        onChangePesquisaCanalDistribuicao({
          label: optionCanalDistribuicao.nome,
          value: optionCanalDistribuicao.id,
        });
      }
      setFila(null);
    } else {
      setFila(value);
    }
  }

  function onChangePesquisaCanalDistribuicao(e) {
    pesquisaCanalDistribuicaoSelect.upDateValue(e.value);
    pesquisaCanalDistribuicaoSelect.upDateDefaultValue(e || "");
    const formikInstance = formikRef?.current;
    if (formikInstance) {
      formikInstance.setFieldValue("canalDistribuicaoId", e.value);
      e.value && setTimeout(() => formikInstance.setFieldTouched("canalDistribuicaoId", true));
    }
    setPesquisaCanalDistribuicao(e.value);
  }

  return {
    pesquisaCanalDistribuicaoObjeto,
    pesquisaCanalDistribuicao,
    pesquisaCanaisDistribuicao,
    optionPesquisaCanalDistribuicao,
    onChangePesquisaCanalDistribuicao,
    pesquisaCanalDistribuicaoSelect,
    setPesquisaCanalDistribuicao,
    setPesquisaCanalDistribuicaoSelect,
  };
};

export default usePesquisaCanalDistribuicao;
